import React from 'react';
import headingIcon from 'assets/images/header_icon_qr_shower.svg';
import closeBtn from 'assets/images/close-button.svg';
import { useTranslation } from 'react-i18next';
import containerQr from 'assets/images/container_qr2.png';
import { PopUpContainer, PopUpInnerContent, CloseButtonLink } from './Styles';

const QRCode = require('qrcode');

const PopUpShowerQR = (props) => {
  const { t } = useTranslation();

  let url2 = '';

  QRCode.toDataURL(props.qrContent, (err, url) => {
    url2 = url;
  });

  const getTitle = () => {
    if (props.title) {
      return props.title;
    }

    return t('viewgoalcard_download_app_qr_title');
  };

  const getDescription = () => {
    if (props.description) {
      return props.description;
    }

    const result = (
      <div>
        {t('viewgoalcard_download_app_qr_description_part1')}
        <span style={{ fontWeight: 'bold' }}>
          {t('viewgoalcard_download_app_qr_description_part2')}
        </span>
        {t('viewgoalcard_download_app_qr_description_part3')}
      </div>
    );

    return result;
  };

  return (
    <>
      <PopUpContainer show={props.show}>
        <PopUpInnerContent>
          <div className="heading-icon">
            <img src={headingIcon} alt="Warning Icon" />
            <CloseButtonLink onClick={props.onClose}>
              <span
                className="icon-svg icon-close-button pointer"
                style={{
                  maskImage: `url(${closeBtn})`,
                  WebkitMaskImage: `url(${closeBtn})`,
                  backgroundColor: '#F3A802',
                }}
              />
            </CloseButtonLink>
          </div>
          <div className="popup-content">
            <h3
              style={{
                marginTop: '30px',
                marginBottom: '30px',
              }}
              className="popup-title"
            >
              {getTitle()}

            </h3>
            <p className="popup-description" style={{ marginBottom: '20px' }}>
              {' '}
              {getDescription()}
              {' '}
            </p>

            <div style={{
              backgroundImage: `url(${containerQr})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              width: '50%',
              height: '215px',
              marginRight: 'auto',
              marginLeft: 'auto',
            }}
            >
              <img style={{ marginTop: '25px' }} src={`${url2}`} />
            </div>

          </div>
          <div className="popup-footer">
            {
            props.onBack && (
              <a className="goback-link" onClick={props.onBack}>
                {' '}
                {(props.btnBackText || t('go_back_title'))}
                {' '}
              </a>
            )
          }
          </div>
        </PopUpInnerContent>
        {/* <div className="error-alert-popup popup-details" /> */}
      </PopUpContainer>

    </>
  );
};

export default PopUpShowerQR;
